import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-images-list',
    templateUrl: './images-list.component.html',
    styleUrls: ['./images-list.component.scss'],
    standalone: false
})
export class ImagesListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
